// extracted by mini-css-extract-plugin
export var fileUpload = "_fj-1";
export var modalButton = "_fj-0";